import { external as externalScript } from '../../utils/script'
import { getSite } from '../../application/pageDataObject'

function loadAmplitudeScript() {
  externalScript.load({
    name: 'amplitude',
    loadNow: true,
  })
}

export function initTheDuelExternalScripts() {
  if ('theduel' === getSite()) {
    loadAmplitudeScript()
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/initTheDuelExternalScripts.js